import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { HeroTerminal } from './components/HeroTerminal';
import { StrategyBreakdown } from './components/StrategyBreakdown';
import { PropFirmBanner } from './components/PropFirmBanner';
import { OfferSection } from './components/OfferSection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div id="top" className="min-h-screen w-full bg-ink font-sans" data-id="element-0" data-mp="2rknmgfavhese">
      <SiteHeader data-id="element-1" data-mp="2rit335f91uqf" />
      <main data-id="element-2" data-mp="2mluawsf5bxuv">
        <HeroTerminal data-id="element-3" data-mp="2mmce69087cca" />
        <StrategyBreakdown data-id="element-4" data-mp="2mmvjmq8ow89f" />
        <PropFirmBanner data-id="element-5" data-mp="2mnnfm2678808" />
        <OfferSection data-id="element-6" data-mp="31aqdi9yfoio3" />
      </main>
      <SiteFooter data-id="element-7" data-mp="31ayvgg9eye65" />
    </div>;
}